<style lang="less" scoped>
@import '../../../style/common/variable';
.kyzxIndex{position: relative;width: 100%;display: flex;flex-direction: column;margin-bottom: 40px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 20px;color: rgb(25, 159, 248);}
.todayNews{margin-top: 18px;position: relative;width: 100%;display: flex;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.first{display: flex;justify-content:space-between;margin-top: 18px;}
  .swiperImg{margin-right: 10px;}
  .newsKYZXvue{text-align: left;}
.guonei{margin-top: 68px;margin-bottom:0px;
  .left{float: left;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;
    span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);}
    img{vertical-align: bottom;}
  }
}
.imgArrayGN{margin-top: -8px;}
.dongmeng{margin: 98px 0px 0px 0px;
  .left{float: left;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;
    span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);}
    img{vertical-align: bottom;}
  }
}
.el-tabs{margin-top: 15px;margin-bottom: 0px;}
.el-tab-pane{padding: 0px;height: 580px;}
/deep/.el-tabs__item {font-size: 16px !important;color: #aaaaaa;}
/deep/.el-tabs__item.is-active{color: #40bafd;}
/deep/.el-tabs__active-bar{background: #40bafd;}
.imgArrayDM{margin-top: -30px;}
.guoji{margin: 58px 0px 0px 0px;
  .left{float: left;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;
    span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);}
    img{vertical-align: bottom;}
  }
}
.imgArrayGJ{margin-top: -8px;}
.right span:hover{color: #13569e;}
@media screen and (max-width: @max-screen){
  .todayNews{margin-top: .2rem; margin-left: .15rem;width: 96vw;}
  .guonei{margin-left: .15rem;width: 96vw;margin-top: .2rem;}
  .guoji{margin-left: .15rem;width: 96vw;margin-top: .2rem;}
  .dongmeng{margin-left: .15rem;width: 96vw;margin-top: .2rem;}
  .dongmeng,.guonei,.todayNews,.guoji{
    span{font-size: .14rem !important;}
  }
  .first{flex-wrap: wrap;justify-content: center;align-items: center;width: 100vw;}
  .dongmengTabs {width: 96vw; margin-left: 1vw; }
  .el-tab-pane{padding: 0px;height: 7.1rem;}
}

</style>

<template>
  <div class="kyzxIndex">
    <div class="todayNews">
      <i class="iconfont icon-jinricaigou" />
      <span>最新资讯 / Latest news</span>
    </div>
    <div class="first">
      <SwiperImg class="swiperImg" :swiperlist="swiperdata" :widthCSH="430" :heightCSH="320" @clickSwiper="goDetails"></SwiperImg>
      <NewsKYZX class="newsKYZXvue" :widthCSH="460" :heightCSH="310"  :newsKYZXList="newsKYZXListdata" @clickNewsKyzx="goDetails"></NewsKYZX>
    </div>
    <div class="guonei">
      <div class="left">
        <i class="iconfont icon-guoneiyou" />
        <span>国内资讯 / Domestic consultation</span>
      </div>
      <div class="right" @click = getMore(1,GNZX)>
        <span>查看更多</span>
        <img src="static/images/zlkindex/arrow.png" />
      </div>
    </div>
    <ImgArray class="imgArrayGN" :imgArrayList="guoneidata" @handleClick="goDetails"></ImgArray>
    <div class="dongmeng">
      <div class="left">
        <i class="iconfont icon-zixun" />
        <span>东盟资讯 / ASEAN Information</span>
      </div>
      <div class="right" @click = getMore(1,activeName)>
        <span>查看更多</span>
        <img src="static/images/zlkindex/arrow.png" />
      </div>
    </div>
    <el-tabs class="dongmengTabs" v-model="activeName">
      <el-tab-pane v-for="(item, index) in this.DongMengdata" :key="index" :label="item.title" :name="item.ssgj">
        <ImgArray class="imgArrayDM" :imgArrayList="item.news" @handleClick="goDetails"></ImgArray>
      </el-tab-pane>
    </el-tabs>
    <div class="guoji">
      <div class="left">
        <i class="iconfont icon-guoji" />
        <span>国际资讯 / Domestic consultation</span>
      </div>
      <div class="right" @click = getMore(1,GJZX)>
        <span>查看更多</span>
        <img src="static/images/zlkindex/arrow.png" />
      </div>
    </div>
    <ImgArray class="imgArrayGJ" :imgArrayList="guojidata" @handleClick="goDetails"></ImgArray>
  </div>
</template>

<script>
/**
 * 何宽
 * 矿业资讯首页部分
 */
import SwiperImg from '../assembly/SwiperImg.vue'
import NewsKYZX from '../assembly/NewsKYZX.vue'
import ImgArray from '../assembly/ImgArray.vue'
export default {
  components: {
    SwiperImg,
    NewsKYZX,
    ImgArray
  },
  data()
  {
    return {
      swiperdata: [], // SwiperImg数据
      newsKYZXListdata: [], // NewsKYZX数据
      GNZX: '2',
      GJZX: '13',
      guoneidata: [], // 国内资讯数据
      // 东盟资讯数据
      Malaysiadata: [], // 马来西亚
      Indonesiadata: [], // 印度尼西亚
      Thailanddata: [], // 泰国
      Philippinesdata: [], // 菲律宾
      Singaporedata: [], // 新加坡
      Bruneidata: [], // 文莱
      Vietnamdata: [], // 越南
      Laosdata: [], // 老挝
      Myanmardata: [], // 缅甸
      Cambodiadata: [], // 柬埔寨
      activeName: '4',
      guojidata: [] // 国际资讯数据
    }
  },
  computed:
  {
    DongMengdata()
    {
      return [
        { id: '1', title: '马来西亚', ssgj: '4', news: this.Malaysiadata },
        { id: '2', title: '印度尼西亚', ssgj: '3', news: this.Indonesiadata },
        { id: '3', title: '泰国', ssgj: '7', news: this.Thailanddata },
        { id: '4', title: '菲律宾', ssgj: '5', news: this.Philippinesdata },
        { id: '5', title: '新加坡', ssgj: '6', news: this.Singaporedata },
        { id: '6', title: '文莱', ssgj: '8', news: this.Bruneidata },
        { id: '7', title: '越南', ssgj: '9', news: this.Vietnamdata },
        { id: '8', title: '老挝', ssgj: '10', news: this.Laosdata },
        { id: '9', title: '缅甸', ssgj: '11', news: this.Myanmardata },
        { id: '10', title: '柬埔寨', ssgj: '12', news: this.Cambodiadata }
      ]
    }
  },
  created()
  {
    this.getKyzxIndex()
  },
  methods:
  {
    // 从数据库获取矿业资讯主页面数据
    getKyzxIndex()
    {
      // 最新资讯数据
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: 'addtime>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 15}
      window.post.getPost(paras).then((ret) =>
      {
        this.swiperdata = []
        this.newsKYZXListdata = []
        for (let i = 0; i < 5; i++)
          this.swiperdata.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb ? ret[0].data[i].thumb : 'static/images/moren.jpg', title: ret[0].data[i].title})
        for (let i = 5; i < 15; i++)
          this.newsKYZXListdata.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb ? ret[0].data[i].thumb : 'static/images/moren.jpg', title: ret[0].data[i].title, introduce: ret[0].data[i].introduce})
      })
      // 国内资讯数据
      let paras1 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 2, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras1).then((ret) =>
      {
        let arrGN = []
        ret[0].data.forEach(item =>
        {
          arrGN.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.guoneidata = arrGN
      })
      // 马来西亚数据
      let paras2 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 4, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras2).then((ret) =>
      {
        let arrMalaysia = []
        ret[0].data.forEach(item =>
        {
          arrMalaysia.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Malaysiadata = arrMalaysia
      })
      // 印度尼西亚数据
      let paras3 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 3, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras3).then((ret) =>
      {
        let arrIndonesia = []
        ret[0].data.forEach(item =>
        {
          arrIndonesia.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Indonesiadata = arrIndonesia
      })
      // 泰国数据
      let paras4 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 7, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras4).then((ret) =>
      {
        let arrThailand = []
        ret[0].data.forEach(item =>
        {
          arrThailand.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Thailanddata = arrThailand
      })
      // 菲律宾数据
      let paras5 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 5, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras5).then((ret) =>
      {
        let arrPhilippines = []
        ret[0].data.forEach(item =>
        {
          arrPhilippines.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Philippinesdata = arrPhilippines
      })
      // 新加坡数据
      let paras6 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 6, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras6).then((ret) =>
      {
        let arrSingapore = []
        ret[0].data.forEach(item =>
        {
          arrSingapore.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Singaporedata = arrSingapore
      })
      // 文莱数据
      let paras7 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 8, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras7).then((ret) =>
      {
        let arrBrunei = []
        ret[0].data.forEach(item =>
        {
          arrBrunei.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Bruneidata = arrBrunei
      })
      // 越南数据
      let paras8 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 9, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras8).then((ret) =>
      {
        let arrVietnam = []
        ret[0].data.forEach(item =>
        {
          arrVietnam.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Vietnamdata = arrVietnam
      })
      // 老挝数据
      let paras9 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 10, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras9).then((ret) =>
      {
        let arrLaos = []
        ret[0].data.forEach(item =>
        {
          arrLaos.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Laosdata = arrLaos
      })
      // 缅甸数据
      let paras10 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 11, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras10).then((ret) =>
      {
        let arrMyanmar = []
        ret[0].data.forEach(item =>
        {
          arrMyanmar.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Myanmardata = arrMyanmar
      })
      // 柬埔寨数据
      let paras11 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 12, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras11).then((ret) =>
      {
        let arrCambodia = []
        ret[0].data.forEach(item =>
        {
          arrCambodia.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.Cambodiadata = arrCambodia
      })
      // 国际资讯数据
      let paras12 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: 13, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras12).then((ret) =>
      {
        let arrGJ = []
        ret[0].data.forEach(item =>
        {
          arrGJ.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.addtime})
        })
        this.guojidata = arrGJ
      })
    },
    // 跳转到矿业资讯详情页面，并将被点击的新闻的id传递到详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
      window.open(url.href, '_self')
    },
    // 跳转到国内资讯、东盟资讯、国际资讯查看更多资讯列表页面，并将被点击的分类名称提交到vuex
    getMore(num, str)
    {
      let url = this.$router.resolve({path: '/KyzxList', query: {catid: num, ssgj: parseInt(str)}})
      window.open(url.href, '_self')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyzxIndex.vue